import { TenantConfig } from '../types/tenant-config';
import TenantService from './tenant-service';
import { Tenants } from '../constants/Tenants';

// Import config files
import Rewards4RacingConfig from '../config/tenants/Rewards4Racing.json';
import Rewards4RacingIrelandConfig from '../config/tenants/Rewards4RacingIreland.json';
import Rewards4ImpsConfig from '../config/tenants/Rewards4Imps.json';
import Rewards4GolfConfig from '../config/tenants/Rewards4Golf.json';
import Rewards4TigersConfig from '../config/tenants/Rewards4Tigers.json';
import Rewards4WolvesConfig from '../config/tenants/Rewards4Wolves.json';
import Rewards4LancashireCricketConfig from '../config/tenants/Rewards4LancashireCricket.json';
import Rewards4AffordableGolfConfig from '../config/tenants/Rewards4AffordableGolf.json';
import Rewards4RugbyLeagueConfig from '../config/tenants/Rewards4Rugbyleague.json';
import Rewards4SportConfig from '../config/tenants/Rewards4Sport.json';

export class TenantConfigService {
    private static instance: TenantConfigService;
    private configCache: Map<string, TenantConfig> = new Map();
    private configs: Record<string, TenantConfig> = {
        [Tenants.Rewards4Racing]: Rewards4RacingConfig as TenantConfig,
        [Tenants.Rewards4RacingIreland]: Rewards4RacingIrelandConfig as TenantConfig,
        [Tenants.Rewards4Imps]: Rewards4ImpsConfig as TenantConfig,
        [Tenants.Rewards4Golf]: Rewards4GolfConfig as TenantConfig,
        [Tenants.Rewards4Tigers]: Rewards4TigersConfig as TenantConfig,
        [Tenants.Rewards4Wolves]: Rewards4WolvesConfig as TenantConfig,
        [Tenants.Rewards4LancashireCricket]: Rewards4LancashireCricketConfig as TenantConfig,
        [Tenants.Rewards4AffordableGolf]: Rewards4AffordableGolfConfig as TenantConfig,
        [Tenants.Rewards4RugbyLeague]: Rewards4RugbyLeagueConfig as TenantConfig,
        [Tenants.Rewards4Sport]: Rewards4SportConfig as TenantConfig,
    };

    private constructor() { }

    public static getInstance(): TenantConfigService {
        if (!TenantConfigService.instance) {
            TenantConfigService.instance = new TenantConfigService();
        }
        return TenantConfigService.instance;
    }

    public getCurrentTenantConfig(): TenantConfig {
        const tenantName = TenantService.getTenantName();

        if (!tenantName) {
            console.error('No tenant name available');
        }

        if (this.configCache.has(tenantName)) {
            return this.configCache.get(tenantName)!;
        }

        const config = this.configs[tenantName];
        if (!config) {
            console.error(`No config found for tenant: ${tenantName}`);
        }

        this.configCache.set(tenantName, config);
        return config;
    }

    // Direct property access with full type safety
    public get branding() {
        return this.getCurrentTenantConfig().branding;
    }

    public get content() {
        return this.getCurrentTenantConfig().content;
    }

    public get features() {
        return this.getCurrentTenantConfig().features;
    }

    public get urls() {
        return this.getCurrentTenantConfig().urls;
    }

    public get settings() {
        return this.getCurrentTenantConfig().settings;
    }

    public get company() {
        return this.getCurrentTenantConfig().company;
    }

    // Utility method to clear cache (useful for testing or tenant switching)
    public clearCache(): void {
        this.configCache.clear();
    }
}

export default TenantConfigService.getInstance();